import { Validators } from '@angular/forms';
import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
import { PolluxFormDisabledEvaluator } from '../../../../../components/common/pollux-form-disabled-evaluator/pollux-form-disabled-evaluator';
import { PolluxValidators } from '../../../../../components/common/pollux-validators/pollux-validators';

export const projectFormConfig: PolluxFormConfig[] = [
  {
    name: 'Oid',
    value: 'Oid',
    disabled: true
  },
  {
    name: 'Name',
    value: 'Name',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'projectCoordinatorId',
    value: 'projectCoordinatorId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]

  },
  {
    name: 'clientBusinessDevelopmentLeadId',
    value: 'clientBusinessDevelopmentLeadId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'currencyId',
    value: 'currencyId',
    disabledTogglable: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly(), PolluxFormDisabledEvaluator.fieldIsSet('ImportAvailable', true)]
  },
  {
    name: 'unitOfLengthId',
    value: 'unitOfLengthId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly(), PolluxFormDisabledEvaluator.fieldIsSet('ImportAvailable', true)]
  },

  {
    name: 'ClientManual',
    value: 'ClientManual',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'CompanyType',
    value: 'CompanyType',
    disabled: true
  },
  {
    name: 'ImportConfigurationId',
    value: 'ImportConfigurationId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(1)]
  },
  {
    name: 'ProjectPhaseValuationId',
    value: 'ProjectPhaseValuationId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'acquiredVia',
    value: 'acquiredVia',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ProjectStdNumberOfProperty',
    value: 'ProjectStdNumberOfProperty',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'NumberOfProperty',
    value: 'NumberOfProperty',
    disabled: true
  },
  {
    name: 'valuationPurpose',
    value: 'valuationPurpose',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ReportScope',
    value: 'ReportScope',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'SpecialAgreement',
    value: 'SpecialAgreement',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'DueDateAgreement',
    value: 'DueDateAgreement',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationVolume',
    value: 'ValuationVolume',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'ProjectStdValuationVolumeCalc',
    value: 'ProjectStdValuationVolumeCalc',
    disabled: true
  },
  {
    name: 'LiabilityTypeId',
    value: 'LiabilityTypeId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'RaciTemplateId',
    value: 'RaciTemplateId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'RecordStatusId',
    keepEnabled: true,
    value: 'RecordStatusId'
  },
  {
    name: 'Portfolio',
    value: 'Portfolio',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'Client',
    value: 'Client',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'OtherRemarks',
    value: 'OtherRemarks',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationMethodIds',
    value: 'ValuationMethodIds',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationLimitIds',
    value: 'ValuationLimitIds',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'CreatedDate',
    value: 'CreatedDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'HistoryLastEntryDate',
    value: 'HistoryLastEntryDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'OwnerUserId',
    value: 'OwnerUserId',
    disabled: true
  },
  {
    name: 'ModifiedByUserId',
    value: 'ModifiedByUserId',
    disabled: true
  },
  {
    name: 'OwnerBuId',
    value: 'OwnerBuId',
    disabled: true
  },
  {
    name: 'ModifiedBuId',
    value: 'ModifiedBuId',
    disabled: true
  },
  {
    name: 'SelectedRecurrentValuationEventIds',
    value: 'SelectedRecurrentValuationEventIds',
    disabled: true
  },
  {
    name: 'ImportAvailable',
    value: 'ImportAvailable',
    disabled: true
  },  
  {
    name: 'filledOnSave',
    fixedValue: 'Filled on save',
    disabled: true
  },
  {
    name: 'DisplayValuesOverTimeId',
    value: 'DisplayValuesOverTimeId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(1)]
  },
  {
    name: 'JllJobId',
    value: 'JllJobId'
  }
];
